// extracted by mini-css-extract-plugin
export default {"SpinnerContainer":"SpinnerContainer_ClFJq_v17-8-1","Spinner":"Spinner_nsNfA_v17-8-1","Spinner__ColorGrayDark50":"Spinner__ColorGrayDark50_LToLS_v17-8-1"};